import { Controller } from '@hotwired/stimulus'

// I-UX-S2-05: a plain click anywhere in a list row opens its detail through the row's real link ([data-row-open],
// the primary cell), so Turbo, frames (_top) and return_to work as for the link itself. Clicks on controls, with a
// modifier or another button, and the end of a text selection are left alone (Cmd/middle-click on the link opens a
// new tab natively; on the rest of the row it does nothing).
const CONTROLS = 'a, button, input, select, textarea, label, summary, details, [popover], [role="menu"], [data-reorder-handle]'

export default class RowLinkController extends Controller<HTMLElement> {
  open(event: MouseEvent): void {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (!(event.target instanceof Element) || event.target.closest(CONTROLS)) return
    if ((window.getSelection()?.toString() ?? '') !== '') return

    event.target.closest('tr')?.querySelector<HTMLElement>('[data-row-open]')?.click()
  }
}
